import { Session } from '@supabase/supabase-js';
import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type { TallerSubscriptionContext } from '../lib/subscription';

interface UserData {
  id: string;
  name: string;
  email: string;
  role: string;
  taller_id: number | null;
  taller: TallerSubscriptionContext | null;
}

interface AuthState {
  session: Session | null;
  user: UserData | null;
  initialized: boolean;
  setSession: (session: Session | null) => void;
  setUser: (user: UserData | null) => void;
  setInitialized: (initialized: boolean) => void;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  initialized: false,
  setSession: (session) => set({ session }),
  setUser: (user) => set({ user }),
  setInitialized: (initialized) => set({ initialized }),
  logout: async () => {
    await supabase.auth.signOut();
    set({ session: null, user: null, initialized: true });
  },
}));
